module.exports = __webpack_public_path__ + "img/9_no.a19e4d33.svg";